/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'leave_page_cancel': 'Auf Seite bleiben',
    'leave_page_message': 'Möchtest du die Seite wirklich verlassen? Nicht gespeicherte Änderungen gehen verloren.',
    'leave_page_ok': 'Seite verlassen',
    'leave_page_title': 'Seite verlassen?',
    'unsaved_changes_message': 'Du hast nicht gespeicherte Änderungen, möchstest du die Seite wirklich verlassen?'
  },

  /* english */
  en: {
    'leave_page_cancel': 'Stay on page',
    'leave_page_message': 'Do you really want to leave the page? Unsaved changes will be lost.',
    'leave_page_ok': 'Leave page',
    'leave_page_title': 'Leave page?',
    'unsaved_changes_message': 'You have unsaved changes, do you really want to leave the page?'
  }
}
